import React from 'react'
import PropTypes from 'prop-types'

import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'

import { DialogWrapper, Strong } from './QuoteBasicInformation.styles'
import {
  ContainerCustomCircle,
  CustomCircleIcon,
  InfoIconCustom
} from '../../components/Custom/CustomCircleIcon.styles'

/**
 * The Quote Bid information dialog's component.
 */
const QuoteBasicInformationDialog = props => {
  const { handleDialogAlert, handleSubmitStatusPurchaseOrder, openDialog, quoteId } = props

  return (
    <Dialog open={openDialog} onClose={handleDialogAlert} verticalAlign="top">
      <DialogWrapper>
        <CustomCircleIcon backgroundColor="info">
          <ContainerCustomCircle>
            <InfoIconCustom />
          </ContainerCustomCircle>
        </CustomCircleIcon>
        <Typography align="center" fontWeight="bold" lineHeight="22px" margin="10px 10px" variant="h4">
          La Compra Ágil ID: {quoteId} volverá a estado cerrada
        </Typography>
        <Typography align="center" fontSize="14px" lineHeight="18px" variant="body2">
          Podrás seleccionar otra cotización y emitir la orden de compra correspondiente.
          <Strong> Esta acción es irreversible.</Strong>
        </Typography>

        <Button color="primary" margin="20px 0 20px" onClick={handleSubmitStatusPurchaseOrder} type="button">
          Confirmar cambio de estado
        </Button>
        <Button onClick={handleDialogAlert} type="button" variant="outlined" width="180px">
          Volver
        </Button>
      </DialogWrapper>
    </Dialog>
  )
}

QuoteBasicInformationDialog.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  handleDialogAlert: PropTypes.func.isRequired,
  handleSubmitStatusPurchaseOrder: PropTypes.func.isRequired,
  quoteId: PropTypes.string.isRequired
}

export default QuoteBasicInformationDialog
